import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "../../components/ScrollToTop";
import AdminAuthCheck from "../../components/AuthCheck/AdminAuthCheck";
import ClientLayout from "../../components/ClientLayout";

import Signin from "../../views/signin";
import ForgotPassword from "../../views/forget-password-1";
import ForgotPassword2 from "../../views/forget-password-2";
import ForgotPassword3 from "../../views/forget-password-3";
import Dashboard from "../../views/dashboard";
import Teachers from "../../views/teachers";
import AddTeacher from "../../views/teachers/addTeacher";
import TeacherAttendance from "../../views/teachers/teacherAttendance";
import TeacherDetails from "../../views/teachers/teacherDetails";
import Profile from "../../views/profile";
import ChangePass from "../../views/profile/changePass";
import Children from "../../views/children/index";
import ChildDetails from "../../views/children/childDetails";
import ChildAttendance from "../../views/children/childAttendance";
import AddChild from "../../views/children/addChild";
import Parents from "../../views/parents/index";
import ParentDetails from "../../views/parents/parentDetails";
import AddParent from "../../views/parents/addParent";
import Classes from "../../views/classroom";
import ClassroomDetails from "../../views/classroom/classroomDetails";
import AddClassroom from "../../views/classroom/addClassroom";
import Inventory from "../../views/inventory";
import AddInventory from "../../views/inventory/addInventory";
import InventoryDetails from "../../views/inventory/inventoryDetails";
import Categories from "../../views/categories";
import Holidays from "../../views/holidays";
import Activities from "../../views/activities";
import AddActivity from "../../views/activities/addActivity";
import ActivityDetails from "../../views/activities/activityDetails";
import Fees from "../../views/fees";
import AddFee from "../../views/fees/addFee";
import SendFees from "../../views/fees/sendFees";
import FeeDetails from "../../views/fees/feeDetails";
import Homework from "../../views/homework";
import AddHomework from "../../views/homework/addHomework";
import HomeworkDetails from "../../views/homework/homeworkDetails";
import Posts from "../../views/posts";
import AddPost from "../../views/posts/addPost";
import Support from "../../views/support";
import Notifications from "../../views/notifications";
import AddNotification from "../../views/notifications/addNotification";
import NotificationDetails from "../../views/notifications/notificationDetails";
import AdminInbox from "../../views/notifications/AdminInbox";
import Advertisements from "../../views/advertisements";
import AddAdvertisement from "../../views/advertisements/addAdvertisement";
import Galleries from "../../views/gallery";
import Settings from "../../views/settings";

function AdminPage({ title, description, children }) {
  return (
    <AdminAuthCheck>
      <ClientLayout head={{ title, description }}>
        {children}
      </ClientLayout>
    </AdminAuthCheck>
  );
}

const MyRouter = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route path="/signin" element={<Signin />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/forgot-password-2" element={<ForgotPassword2 />} />
      <Route path="/forgot-password-3" element={<ForgotPassword3 />} />

      <Route path="/" element={<AdminPage title="Dashboard"><Dashboard /></AdminPage>} />

      <Route path="/teachers" element={<AdminPage title="Teachers"><Teachers /></AdminPage>} />
      <Route path="/teachers/addTeacher" element={<AdminPage title="Add New Teacher"><AddTeacher /></AdminPage>} />
      <Route path="/teachers/edit/:id" element={<AdminPage title="Edit Teacher"><AddTeacher /></AdminPage>} />
      <Route path="/teachers/attendance/:id" element={<AdminPage title="Teacher Attendance"><TeacherAttendance /></AdminPage>} />
      <Route path="/teachers/:id" element={<AdminPage title="Teacher Details"><TeacherDetails /></AdminPage>} />

      <Route path="/children" element={<AdminPage title="Children"><Children /></AdminPage>} />
      <Route path="/children/addChild" element={<AdminPage title="Add Child"><AddChild /></AdminPage>} />
      <Route path="/children/edit/:id" element={<AdminPage title="Edit Child"><AddChild /></AdminPage>} />
      <Route path="/children/attendance/:id" element={<AdminPage title="Student Attendance"><ChildAttendance /></AdminPage>} />
      <Route path="/children/:id" element={<AdminPage title="Child Details"><ChildDetails /></AdminPage>} />

      <Route path="/classes" element={<AdminPage title="Classes"><Classes /></AdminPage>} />
      <Route path="/classes/addClass" element={<AdminPage title="Add Class"><AddClassroom /></AdminPage>} />
      <Route path="/classes/edit/:id" element={<AdminPage title="Edit Class"><AddClassroom /></AdminPage>} />
      <Route path="/classes/:id" element={<AdminPage title="Class Details"><ClassroomDetails /></AdminPage>} />

      <Route path="/parents" element={<AdminPage title="Parents"><Parents /></AdminPage>} />
      <Route path="/parents/addParent" element={<AdminPage title="Add Parent"><AddParent /></AdminPage>} />
      <Route path="/parents/edit/:id" element={<AdminPage title="Edit Parent"><AddParent /></AdminPage>} />
      <Route path="/parents/:id" element={<AdminPage title="Parent Details"><ParentDetails /></AdminPage>} />

      <Route path="/inventory" element={<AdminPage title="Inventory"><Inventory /></AdminPage>} />
      <Route path="/inventory/addInventory" element={<AdminPage title="Add Inventory"><AddInventory /></AdminPage>} />
      <Route path="/inventory/edit/:id" element={<AdminPage title="Edit Inventory"><AddInventory /></AdminPage>} />
      <Route path="/inventory/:id" element={<AdminPage title="Inventory Details"><InventoryDetails /></AdminPage>} />

      <Route path="/categories" element={<AdminPage title="Categories"><Categories /></AdminPage>} />

      <Route path="/holidays" element={<AdminPage title="Holidays"><Holidays /></AdminPage>} />

      <Route path="/activities" element={<AdminPage title="Activities"><Activities /></AdminPage>} />
      <Route path="/activities/addActivity" element={<AdminPage title="Add Activity"><AddActivity /></AdminPage>} />
      <Route path="/activities/edit/:id" element={<AdminPage title="Edit Activity"><AddActivity /></AdminPage>} />
      <Route path="/activities/:id" element={<AdminPage title="Activity Details"><ActivityDetails /></AdminPage>} />

      <Route path="/fees" element={<AdminPage title="Fees"><Fees /></AdminPage>} />
      <Route path="/fees/add" element={<AdminPage title="Add Fee"><AddFee /></AdminPage>} />
      <Route path="/fees/send" element={<AdminPage title="Send Vouchers"><SendFees /></AdminPage>} />
      <Route path="/fees/edit/:id" element={<AdminPage title="Edit Fee"><AddFee /></AdminPage>} />
      <Route path="/fees/:id" element={<AdminPage title="Fee Details"><FeeDetails /></AdminPage>} />

      <Route path="/homework" element={<AdminPage title="Homework"><Homework /></AdminPage>} />
      <Route path="/homework/add" element={<AdminPage title="Add Homework"><AddHomework /></AdminPage>} />
      <Route path="/homework/edit/:id" element={<AdminPage title="Edit Homework"><AddHomework /></AdminPage>} />
      <Route path="/homework/:id" element={<AdminPage title="Homework Details"><HomeworkDetails /></AdminPage>} />

      <Route path="/posts" element={<AdminPage title="Posts"><Posts /></AdminPage>} />
      <Route path="/posts/add" element={<AdminPage title="Add Post"><AddPost /></AdminPage>} />
      <Route path="/posts/edit/:id" element={<AdminPage title="Edit Post"><AddPost /></AdminPage>} />

      <Route path="/support" element={<AdminPage title="Support" description="Chat with teachers and parents"><Support /></AdminPage>} />
      <Route path="/support/:id" element={<AdminPage title="Support" description="Chat with teachers and parents"><Support /></AdminPage>} />

      <Route path="/inbox" element={<AdminPage title="Notifications" description="Realtime admin alerts"><AdminInbox /></AdminPage>} />
      <Route path="/notifications" element={<AdminPage title="Notices" description="School alerts and announcements"><Notifications /></AdminPage>} />
      <Route path="/notifications/add" element={<AdminPage title="Add Notice"><AddNotification /></AdminPage>} />
      <Route path="/notifications/edit/:id" element={<AdminPage title="Edit Notice"><AddNotification /></AdminPage>} />
      <Route path="/notifications/:id" element={<AdminPage title="Notice Details"><NotificationDetails /></AdminPage>} />

      <Route path="/gallery" element={<AdminPage title="Gallery" description="Photo albums for the parent app"><Galleries /></AdminPage>} />

      <Route path="/advertisements" element={<AdminPage title="Advertisements" description="Home screen banner ads for the parent app"><Advertisements /></AdminPage>} />
      <Route path="/advertisements/add" element={<AdminPage title="Add Advertisement"><AddAdvertisement /></AdminPage>} />
      <Route path="/advertisements/edit/:id" element={<AdminPage title="Edit Advertisement"><AddAdvertisement /></AdminPage>} />

      <Route path="/settings" element={<AdminPage title="Settings" description="App modules and admin preferences"><Settings /></AdminPage>} />

      <Route path="/profile" element={<AdminPage title="Profile" description="Manage your admin account"><Profile /></AdminPage>} />
      <Route path="/profile/changePass" element={<AdminPage title="Change Password" description="Update your admin password"><ChangePass /></AdminPage>} />
    </Routes>
  </BrowserRouter>
);

export default MyRouter;
